var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2083 8L15 3.20833C15.6042 2.60417 15.6042 1.60417 15 1C14.3958 0.395833 13.3958 0.395833 12.7917 1L8 5.79167L3.20833 1C2.60417 0.395833 1.60417 0.395833 1 1C0.395833 1.60417 0.395833 2.60417 1 3.20833L5.79166 8L1 12.7917C0.395833 13.3958 0.395833 14.3958 1 15C1.3125 15.3125 1.70833 15.4583 2.10417 15.4583C2.5 15.4583 2.89583 15.3125 3.20833 15L8 10.2083L12.7917 15C13.1042 15.3125 13.5 15.4583 13.8958 15.4583C14.2917 15.4583 14.6875 15.3125 15 15C15.6042 14.3958 15.6042 13.3958 15 12.7917L10.2083 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleWhite);
export default __webpack_public_path__ + "static/media/close-circle-white.61bba812a7b2c42253cab90fe5d32b66.svg";
export { ForwardRef as ReactComponent };